import { Helper } from '../Helper';
export class MapForEachHelper extends Helper {
    constructor(options) {
        super();
        this.each = options.each;
    }
    emit(sb, node, options) {
        sb.emitSysCall(node, 'Neo.Iterator.Create');
        sb.emitHelper(node, options, sb.helpers.rawIteratorForEach({
            each: this.each,
        }));
    }
}

//# sourceMappingURL=MapForEachHelper.js.map
